<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_86_777)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.7889 13C19.7889 12.5176 19.3349 12.1566 18.427 11.4346L14.3808 8.21696C12.9716 7.09632 12.2669 6.536 11.7014 6.80881C11.136 7.08162 11.136 7.98186 11.136 9.78234V11.1395H8.67164C7.64409 11.1395 6.8111 11.9724 6.8111 13C6.8111 14.0275 7.64409 14.8605 8.67164 14.8605H11.136V16.2177C11.136 18.0181 11.136 18.9184 11.7014 19.1912C12.2669 19.464 12.9716 18.9037 14.3808 17.783L18.427 14.5654C19.3349 13.8434 19.7889 13.4824 19.7889 13Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_86_777">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
